import { Reveal } from "./Reveal";
import { HOST } from "../data/content";

const STATS = [
  { value: HOST.rating, label: "Guest rating" },
  { value: HOST.reviewsTotal, label: "Guest reviews" },
  { value: HOST.responseRate, label: "Response rate" },
  { value: "1 hr", label: "Response time" },
];

export const About = () => (
  <section id="about" data-testid="about-host-section" className="py-24 md:py-36">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-16 px-6 lg:grid-cols-12 lg:px-10">
      <div className="relative lg:col-span-5">
        <Reveal>
          <div className="relative">
            <div className="absolute -top-6 -left-6 h-full w-full rounded-[2rem] border border-[#C4623C]/40" />
            <div className="relative aspect-square overflow-hidden rounded-[2rem]" data-testid="host-portrait-frame">
              <img
                src={HOST.portrait}
                alt={HOST.portraitAlt}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-[1.6s] ease-out hover:scale-105"
              />
            </div>
            <div className="absolute -bottom-7 right-4 rounded-2xl bg-[#201B17] px-6 py-4 md:right-8">
              <p className="font-mono-accent text-[10px] uppercase tracking-[0.22em] text-[#E3A387]">
                Your host
              </p>
              <p className="font-serif-display mt-1 text-2xl italic text-[#FBF8F3]">{HOST.name}</p>
            </div>
          </div>
        </Reveal>
      </div>

      <div className="flex flex-col justify-center lg:col-span-6 lg:col-start-7">
        <Reveal>
          <p className="font-mono-accent text-[11px] uppercase tracking-[0.28em] text-[#C4623C]">
            Meet your host
          </p>
          <h2 className="font-serif-display mt-5 text-4xl leading-[1.05] tracking-tight text-[#201B17] sm:text-5xl lg:text-6xl">
            Crafting calm city stays for mind <em className="text-[#C4623C]">and soul.</em>
          </h2>
        </Reveal>
        {HOST.bio.map((paragraph, i) => (
          <Reveal key={paragraph.slice(0, 12)} delay={0.1 + i * 0.1}>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-[#63584E] md:text-lg">
              {paragraph}
            </p>
          </Reveal>
        ))}
        <Reveal delay={0.3}>
          <p className="font-serif-display mt-8 text-3xl italic text-[#201B17]">— {HOST.firstName}</p>
          <p className="font-mono-accent mt-3 text-[10px] uppercase tracking-[0.18em] text-[#8C7F72]">
            Speaks {HOST.languages} · Identity verified
          </p>
        </Reveal>
        <Reveal delay={0.35}>
          <div className="mt-12 grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-[#E4DBD0] bg-[#E4DBD0] md:grid-cols-4">
            {STATS.map((stat) => (
              <div key={stat.label} className="bg-[#F6F1E8] px-5 py-6" data-testid={`host-stat-${stat.label.toLowerCase().replace(/\s+/g, "-")}`}>
                <p className="font-serif-display text-3xl text-[#201B17] md:text-4xl">{stat.value}</p>
                <p className="font-mono-accent mt-2 text-[10px] uppercase tracking-[0.18em] text-[#8C7F72]">
                  {stat.label}
                </p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
